import {useNavigation} from '@react-navigation/native';
import {useSelector} from 'Provider';
import React from 'react';

import FilterBar from 'components/Offers/Filters/FilterBar';
import {
  offersFilteredSelector,
  shouldApplyFiltersSelector,
} from 'store/offers/offers.selectors';

const ConnectedFilterBar = () => {
  const navigation = useNavigation();
  const filteredOffers = useSelector(offersFilteredSelector);
  const hasFiltersApplied = useSelector(shouldApplyFiltersSelector);

  return (
    <FilterBar
      filteredOffersCount={filteredOffers.results.length}
      hasFiltersApplied={hasFiltersApplied}
      navigation={navigation}
    />
  );
};

export default ConnectedFilterBar;
